import { serviceName } from '../resources/serviceConstants';
import { AWARDS_LIST } from '../resources/endPoint';

export const getAwardDetails = (userId) => {
  // API call to fetch awards details
  const url = userId ? `${AWARDS_LIST}?userId=${userId}` : AWARDS_LIST;

  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};

export const addAward = (userId, awardName, description, year) => {
  // API call to add award
  const data = {
    user_id: userId,
    award_name: awardName,
    description: description,
    year: year,
  };

  return {
    url: AWARDS_LIST,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};

export const deleteAward = (awardId) => {
  // API call to delete award
  const url = `${AWARDS_LIST}?awardId=${awardId}`;

  return {
    url: url,
    method: 'delete',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};
